<template>
    <div class="bank">
        <section class="home-cards">
        <h4>Bank Account Details</h4>
        <hr class="hr">
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/bank.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>INDO ZAMBIA BANK</h5>
                </div>
                <div class="feature-detail">
                <p>Branch Name: Chilenje Branch</p>
                <p>Account Name: Inspire Leadership School</p>
                <p>Account Number: 0282030000049</p>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Bank',
  components: { }
}
</script>

<style>
.bank .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.bank .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.bank .home-cards .home-cards-main {
  padding: 1em;
  max-width: 600px;
  margin: 0 auto;
}
.bank .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.bank .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.bank .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.bank .feature p {
  color: var(--inspire-charcoal);
}
.bank .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.bank .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.bank .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
</style>
